//正式环境配置
module.exports = {
    baseUrl : 'https://apiv2.hichar.cn/', //http://api.v2.yd.hichar.cn/
    baseUrl900C: 'http://cmp.hichar.cn:58083/',
}